import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo1_Rodrigo } from '../../../../../utils/ES/Modals/directors';

const ModalVideoRodrigo1 = () => {
  return (
    <>
      <ModalVideo
        id="rodrigo-video-1"
        dataText={TextVideo1_Rodrigo}
        videoSrc="https://player.vimeo.com/video/472716564?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_RODRIGO_1"
      />
    </>
  );
};

export default ModalVideoRodrigo1;
